import PropTypes from 'prop-types';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import { buttonSubmitStyle } from '../../../components/ButtonSubmit';

const Button = styled.button`
  ${tw`mx-def mb-abs2 mx-auto`}
  ${buttonSubmitStyle}
  width: max-content;
`;
const ArticleButtonLink = ({ content, href }) => (
  <Button as="a" href={href}>
    {content}
  </Button>
);

ArticleButtonLink.propTypes = {
  content: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};

export default ArticleButtonLink;
